import moment from "moment";

// `created` arrives as "DD-MM-YYYY HH:mm" although the API docs call it an ISO date-time,
// so both are read. dayjs cannot parse the first without a plugin this app does not load.
const CREATED_FORMATS = ["DD-MM-YYYY HH:mm", moment.ISO_8601];

/**
 * When an appointment was booked, for reception answering "who booked this in, and when?"
 * (KIN-1881). Returns null for a missing or unreadable value, so the row can be left out.
 */
export const formatBookedAt = (created) => {
  if (!created) return null;

  const bookedAt = moment(created, CREATED_FORMATS, true);

  return bookedAt.isValid() ? bookedAt.format("DD MMM YYYY, HH:mm") : null;
};
